<template>
  <div class="container">
    <!-- CTA: NONE -->
    <CtaCantSeePhotosInStay :event-name="eventName" :pica-code="picaCode" v-if="!canSeeMedia" />
    <template v-else-if="checkin.user_cta === userCTA.NONE && !hasMedias">
      <CtaUploading :event-name="eventName" :pica-code="picaCode" v-if="!isTaggingCompleted"/>
      <template v-else>
        <template v-if="eventIsStarted">
          <CtaNoPhotosInStay :event-name="eventName" :pica-code="picaCode"
                             :can-purchase-during-stay="canPurchaseDuringStay"
                             v-if="isBoolean(canPurchaseDuringStay)"/>
          <CtaSupport :event-name="eventName" :pica-code="picaCode" v-else/>
        </template>
        <CtaIncomingEvent :event-name="eventName" :pica-code="picaCode" v-else/>
      </template>
    </template>

    <!-- CTA: SUPPORT -->
    <CtaSupport :event-name="eventName"
                :pica-code="picaCode"
                v-else-if="checkin.user_cta === userCTA.SUPPORT"/>

    <!-- CTA: FACE_CHECKIN -->
    <CtaFaceCheckin :event-name="eventName"
                    :pica-code="picaCode"
                    v-else-if="checkin.user_cta === userCTA.FACE_CHECKIN && !hideUserCta"
                    @click="onFaceCheckinCta"/>

  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {userCTA} from "@/consts";
import CtaUploading from "@/domain/checkinDetail/cta/CtaUploading.vue";
import CtaFaceCheckin from "@/domain/checkinDetail/cta/CtaFaceCheckin.vue";
import CtaNoPhotosInStay from "@/domain/checkinDetail/cta/CtaNoPhotosInStay.vue";
import CtaIncomingEvent from "@/domain/checkinDetail/cta/CtaIncomingEvent.vue";
import CtaSupport from "@/domain/checkinDetail/cta/CtaSupport.vue";
import {isBoolean} from "lodash";
import CtaCantSeePhotosInStay from "@/domain/checkinDetail/cta/CtaCantSeePhotosInStay.vue";

export default {
  name: "UserCtas",
  emits: ['face-checkin-cta'],
  components: {CtaCantSeePhotosInStay, CtaSupport, CtaIncomingEvent, CtaNoPhotosInStay, CtaFaceCheckin, CtaUploading},
  props: {
    hideUserCta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'checkin',
      'picaCode',
      'isTaggingCompleted',
      'eventName',
      'canPurchaseDuringStay',
      'canSeeMedia'
    ]),
    ...mapGetters('galleries', [
      'totalMediasCount'
    ]),
    userCTA() {
      return userCTA
    },
    eventIsStarted() {
      return new Date() > new Date(this.checkin.event_start_at)
    },
    hasMedias() {
      return this.totalMediasCount > 0
    }
  },
  methods: {
    isBoolean,
    onFaceCheckinCta() {
      this.$emit('face-checkin-cta')
    }
  }
}
</script>